import {InfoUser, ListUser, LogoutUser} from "@/api/user";

const state = () => ({
  users: [],
  currentUser: {},
})

// getters
const getters = {}

// actions
const actions = {
  async fetchUsers( { commit, dispatch }, params) {
    await dispatch("loading/setLoading", true, {root: true})
    ListUser(params).then((data) => {
      commit('setUsers', data.data.data)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
  fetchCurrentUser( { commit } ) {
    InfoUser().then((data) => {
      if (data && data.data && data.data) {
        commit('setCurrentUser', data.data.data)
      }
    }).catch((err) => {
      console.log(err)
    })
  },

  async logout({ commit, dispatch }) {
    console.log(commit, dispatch);
    let isRegistered = false; // 默认为未注册
    try {
      await LogoutUser();
      // 清除 token
      await dispatch('cookie/fetchRemoveToken', null, { root: true });
      isRegistered = true;
    } catch (err) {
      console.log('注销失败：', err);
    }
    return isRegistered;
  }

}



// mutations
const mutations = {
  setUsers(state, users) {
    console.log(users)
    state.users = users
  },
  setCurrentUser(state, user) {
    state.currentUser = user
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
